/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 832:
/***/ (function() {

window.theme = window.theme || {};
window.theme.loading = {
  show: function show() {
    var loader = document.querySelector('.pepperfield-loading');

    if (loader) {
      loader.classList.add('--active');
    }
  },
  hide: function hide() {
    var loader = document.querySelector('.pepperfield-loading');

    if (loader) {
      loader.classList.remove('--active');
    }
  }
};

/***/ }),

/***/ 807:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var originalFetch = window.fetch;

window.fetch = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(resource, init) {
    var url,
        cartUrlsToCheck,
        isCartChange,
        response,
        cart,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = new URL(resource, window.location.href);
            cartUrlsToCheck = ['/cart/add', '/cart/add.js', '/cart/change', '/cart/change.js', '/cart/update', '/cart/update.js'];
            isCartChange = cartUrlsToCheck.some(function (path) {
              return url.pathname.includes(path);
            });

            if (!(init && init.bypassCustomFetch)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", originalFetch.apply(this, _args));

          case 5:
            if (isCartChange && window.autoProduct) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", originalFetch.apply(this, _args));

          case 7:
            _context.next = 9;
            return fetch('/cart.json');

          case 9:
            response = _context.sent;
            _context.next = 12;
            return response.json();

          case 12:
            cart = _context.sent;

            if (!cart.item_count) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", originalFetch.apply(this, _args));

          case 15:
            _context.next = 17;
            return addAutoProductToCart();

          case 17:
            return _context.abrupt("return", originalFetch.apply(this, _args));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

function addAutoProductToCart() {
  return _addAutoProductToCart.apply(this, arguments);
}

function _addAutoProductToCart() {
  _addAutoProductToCart = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: window.autoProduct,
                  quantity: 1
                }]
              }),
              bypassCustomFetch: true
            });

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _addAutoProductToCart.apply(this, arguments);
}

/***/ }),

/***/ 402:
/***/ (function() {

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

window.engravingLogic = {
  currentVariant: null,
  engravingData: null,
  init: function init(variant) {
    var self = this;
    self.variantSet(variant);
    document.addEventListener("DOMContentLoaded", function (event) {
      var input = document.getElementById('box-engraving');

      if (!input) {
        return;
      }

      input.addEventListener('keyup', function () {
        self.updateProductForm(input);
      });

      var _iterator = _createForOfIteratorHelper(document.querySelectorAll('.close-engraving-popup')),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          element.addEventListener('click', function () {
            event.preventDefault();
            self.togglePopup(false);
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(document.querySelectorAll('.open-engraving-popup')),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _element = _step2.value;

          _element.addEventListener('click', function () {
            event.preventDefault();
            self.togglePopup(true);
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      ;
    });
    window.addEventListener('resize', function () {
      self.resizeText();
    });
  },
  getVariantData: function getVariantData() {
    var _this = this;

    if (!window.variantsWithEngraving) {
      return null;
    }

    return window.variantsWithEngraving.find(function (variant) {
      return parseInt(variant.variantId) === parseInt(_this.currentVariant);
    }) || null;
  },
  variantSet: function variantSet(variant) {
    this.currentVariant = variant;
    this.engravingData = this.getVariantData();
    this.engravingInputToggler();
    this.engravingDaysToggler();
    this.engravingPopupOpener();
    this.updateProductForm(document.getElementById('box-engraving'));
  },
  engravingInputToggler: function engravingInputToggler() {
    this.toggleElement('engraving', '[data-id="js-engraving-input"]');
  },
  engravingDaysToggler: function engravingDaysToggler() {
    this.toggleElement('showDaysText', '[data-id="js-engraving-days"]');
  },
  engravingPopupOpener: function engravingPopupOpener() {
    this.toggleElement('image', '[data-id="js-engraving-input"] .open-engraving-popup');
  },
  toggleElement: function toggleElement(key, elementSelector) {
    var show = false;

    if (this.engravingData && this.engravingData[key]) {
      show = true;
    }

    var element = document.querySelector(elementSelector);

    if (!element) {
      return;
    }

    if (show) {
      element.classList.add('--active');
      return;
    }

    element.classList.remove('--active');
  },
  updateProductForm: function updateProductForm(input) {
    if (!input) {
      return;
    }

    var productElement = input.closest('.main-product');

    if (!productElement) {
      return;
    }

    var productForm = productElement.querySelector('[data-type="add-to-cart-form"]');

    if (!productForm) {
      return;
    }

    var productFormInput = productForm.querySelector('[name="properties[Engraving]"]');

    if (!this.engravingData || !this.engravingData.engraving) {
      if (productFormInput) {
        productFormInput.remove();
      }

      return false;
    }

    if (productFormInput) {
      productFormInput.value = input.value;
      return;
    }

    var newProductFormInput = document.createElement('input');
    newProductFormInput.type = 'hidden';
    newProductFormInput.value = input.value;
    newProductFormInput.name = 'properties[Engraving]';
    productForm.append(newProductFormInput);
  },
  setEngravingPopup: function setEngravingPopup() {
    if (!this.engravingData || !this.engravingData.image) {
      return;
    }

    var img = document.querySelector('.engraving-popup .engraving-image img');

    if (img) {
      img.src = this.engravingData.image;
      return;
    }

    var popupImageElement = document.querySelector('.engraving-popup .engraving-image');

    if (!popupImageElement) {
      return;
    }

    var newImg = document.createElement('img');
    newImg.src = this.engravingData.image;
    popupImageElement.appendChild(newImg);
  },
  togglePopup: function togglePopup() {
    var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var popupElement = document.querySelector('.engraving-popup');

    if (!popupElement) {
      return;
    }

    if (show) {
      this.setEngravingPopup();
      popupElement.classList.add('--active');
      document.querySelector('.engraving-popup .engraving-text').innerHTML = document.getElementById('box-engraving').value;
      this.resizeText();
      return;
    }

    popupElement.classList.remove('--active');
  },
  resizeText: function resizeText() {
    var popupImageElement = document.querySelector('.engraving-popup .engraving-image');
    var width = popupImageElement.offsetWidth;
    var baseWidth = 360;
    var baseFontSize = 20;
    var newFontSize = baseFontSize * (width / baseWidth);
    document.querySelector('.engraving-popup .engraving-text').style.fontSize = newFontSize + 'px';
  }
};

/***/ }),

/***/ 285:
/***/ (function() {

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

window.mapsApp = {
  renderMap: function renderMap(mapElement) {
    var markers = mapElement.querySelectorAll('.marker');
    var args = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      panControl: true,
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      overviewMapControl: true,
      gestureHandling: "cooperative",
      styles: [{
        stylers: [{
          saturation: -100
        }, {
          lightness: 0
        }]
      }]
    };

    if (mapElement.getAttribute('data-without-icons')) {
      args.zoomControl = false;
      args.scaleControl = false;
      args.streetViewControl = false;
      args.overviewMapControl = false;
      args.panControl = false;
      args.mapTypeControl = false;
      args.fullscreenControl = false;
    }

    var map = new google.maps.Map(mapElement, args);
    map.markers = [];

    var _iterator = _createForOfIteratorHelper(markers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var marker = _step.value;
        window.mapsApp.addMarker(marker, map);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    window.mapsApp.centerMap(map);
  },
  addMarker: function addMarker(markerEl, map) {
    var lat = parseFloat(markerEl.getAttribute('data-lat'));
    var lng = parseFloat(markerEl.getAttribute('data-lng'));
    var name = markerEl.getAttribute('data-name');
    var address = markerEl.getAttribute('data-address');
    var link = markerEl.getAttribute('data-link');
    var linkText = markerEl.getAttribute('data-link-text');
    var icon = markerEl.getAttribute('data-icon');
    var logo = markerEl.getAttribute('data-logo');
    var latlng = new google.maps.LatLng(lat, lng);
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      draggable: false,
      icon: icon
    });
    map.markers.push(marker);
    var contentString = '';

    if (logo) {
      contentString += "<div class=\"logo\"><img src=\"".concat(logo, "\" /></div>");
    }

    contentString += "<div class=\"name\">".concat(name, "</div>");
    contentString += "<div class=\"address\">".concat(address, "</div>");

    if (link) {
      contentString += "<div class=\"link\"><a href=\"".concat(link, "\" target=\"_blank\">").concat(linkText, "</a></div>");
    }

    var infowindow = new google.maps.InfoWindow({
      content: "<div class=\"marker-content\">".concat(contentString, "</div>")
    });
    google.maps.event.addListener(marker, 'click', function () {
      if (window.mapsApp.currentInfowindow) {
        window.mapsApp.currentInfowindow.close();
      }

      infowindow.open(map, marker);
      window.mapsApp.currentInfowindow = infowindow;
    });
  },
  centerMap: function centerMap(map) {
    var bounds = new google.maps.LatLngBounds();

    var _iterator2 = _createForOfIteratorHelper(map.markers),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var marker = _step2.value;
        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      map.fitBounds(bounds);
    }
  },
  initMap: function initMap(selector) {
    var map = document.querySelector(selector);

    if (!map) {
      return;
    }

    window.mapsApp.renderMap(map);
  },
  initMaps: function initMaps() {
    document.addEventListener('DOMContentLoaded', function () {
      var _iterator3 = _createForOfIteratorHelper(document.querySelectorAll('[data-interactive-map]')),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var map = _step3.value;
          window.mapsApp.renderMap(map);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
  }
};

/***/ }),

/***/ 664:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

window.pepperfieldAddToCart = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(event) {
    var form, formData, button, response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            form = event.target;
            formData = new FormData(form);
            button = form.querySelector('.pepperfield-buy-button');

            if (button) {
              button.classList.add('pepperfield-buy-button-loading');
            }

            _context.prev = 5;
            _context.next = 8;
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: formData
            });

          case 8:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            throw new Error('Failed to add item to cart');

          case 11:
            _context.next = 13;
            return response.json();

          case 13:
            data = _context.sent;
            console.log('Item added to cart:', data);
            Alpine.store('xMiniCart').openCart();
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](5);
            console.error('Error:', _context.t0);

          case 21:
            _context.prev = 21;

            if (button) {
              button.classList.remove('pepperfield-buy-button-loading');
            }

            return _context.finish(21);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 18, 21, 24]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 524:
/***/ (function() {

window.sga = window.sga || {};

window.sga.scrollToAnchor = function (element) {
  var anchor = element.getAttribute('data-scroll-to-anchor');

  if (!anchor) {
    return;
  }

  var scrollToElement = document.querySelector('[data-anchor="' + anchor + '"]');

  if (!scrollToElement) {
    return;
  }

  var textElement = scrollToElement.querySelector('.truncate-text');
  var readMoreButton = scrollToElement.querySelector('.read-more-button');

  if (textElement && readMoreButton && textElement.classList.contains('overflow-hidden') && !textElement.classList.contains('truncate-expanded')) {
    readMoreButton.click();
  }

  scrollToElement.scrollIntoView({
    behavior: 'smooth'
  });
};

/***/ }),

/***/ 119:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
class ShopifyFrontendHelper {
    constructor() {
        this.routes = '/';
        if (window.hasOwnProperty('Shopify')) {
            this.routes = window.Shopify.routes.root;
        }
    }
    fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': `application/${type}`, 'Accept': `application/${type}` }
        };
    }
    /* Will add items array to cart */
    async addToCart(items) {
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will add variant of product to cart */
    async addVariantToCart(variantId, quantity, sellingPlan = null) {
        const items = [
            {
                id: variantId,
                quantity: quantity
            }
        ];
        if (sellingPlan) {
            items[0]["selling_plan"] = sellingPlan;
        }
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will remove variant from cart */
    async removeFromCart(variantId) {
        let updates = {};
        updates[variantId] = 0;
        const body = JSON.stringify({ updates: updates });
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will change quantity of variant in cart */
    async updateQuantityInCart(variantId, quantity, itemKey = null, updateSellingPlan = false, sellingPlan = null) {
        const updateBody = {
            id: itemKey ? itemKey : variantId,
            quantity: quantity,
        };
        if (updateSellingPlan) {
            updateBody["selling_plan"] = sellingPlan;
        }
        const body = JSON.stringify(updateBody);
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will change quantity of variant in cart */
    async updateCartItem(updatedItem) {
        const body = JSON.stringify(updatedItem);
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /*
    Search function
    Type: product, page, article, collection
    Unavailable products:
        show: Show unavailable products.
        hide: Hide unavailable products.
        last: Show unavailable products below other matching results.
    Fields: author, body, product_type, tag, title, variants.barcode, variants.sku, variants.title, vendor
    More about parameters: https://shopify.dev/api/ajax/reference/predictive-search
    */
    async search(query, type = 'product', limit = 10, unavailable_products = 'last', fields = 'title,product_type,variants.title,vendor') {
        const url = this.routes
            + 'search/suggest.json?q='
            + query
            + '&resources[type]=' + type
            + '&resources[limit]=' + limit
            + '&resources[options][unavailable_products]=' + unavailable_products
            + '&resources[options][fields]=' + fields;
        return await fetch(url)
            .then((response) => response.json())
            .then((suggestions) => {
            return suggestions.resources.results;
        })
            .catch((e) => {
            return e;
        });
    }
    /* Will clear cart items */
    async clearCartItems() {
        const config = this.fetchConfig();
        return await fetch(this.routes + 'cart/clear.js', Object.assign({}, config))
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
            return e;
        });
    }
    /* Will clear cart items with attributes and properties */
    async clearCartFully() {
        /* First clear attributes and note in cart */
        await fetch('/cart.js').then(result => result.json()).then(async (cart) => {
            for (const attr in cart.attributes) {
                cart.attributes[attr] = null;
            }
            cart.note = '';
            const body = JSON.stringify(cart);
            const config = this.fetchConfig();
            await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))
                .then((response) => { return response.json(); })
                .then((state) => { return state; })
                .catch((e) => {
                return e;
            });
        });
        /* Clear cart  items */
        return await this.clearCartItems();
    }
    /* Will log in customer. Recaptcha has to be disabled. If redirectUrl is empty we don't redirect after login */
    async customerLogin(email, password, redirectUrl = '/account/') {
        let formData = new FormData();
        formData.append('customer[email]', email);
        formData.append('customer[password]', password);
        formData.append('form_type', 'customer_login');
        formData.append('utf8', '✓');
        return await fetch("/account/login", {
            method: "POST",
            mode: "no-cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "form-data"
            },
            body: formData
        })
            .then((response) => { return response.text(); })
            .then((html) => {
            if (!html.includes('/account/logout')) {
                return 'Wrong email or password';
            }
            else {
                if (redirectUrl != '') {
                    location.href = redirectUrl;
                }
                return 'Logged In';
            }
        })
            .catch((e) => {
            return e;
        });
    }
    /* Will log out customer */
    async customerLogout(redirectUrl = '/') {
        return await fetch(this.routes + 'account/logout')
            .then((response) => { })
            .then((state) => {
            if (redirectUrl != '') {
                location.href = redirectUrl;
            }
            return 'Logged Out';
        })
            .catch((e) => {
            return e;
        });
        ;
    }
}
exports.Z = ShopifyFrontendHelper;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXTERNAL MODULE: ./node_modules/shopify-api-js/lib/ShopifyFrontendHelper.js
var ShopifyFrontendHelper = __webpack_require__(119);
;// CONCATENATED MODULE: ./js/libs.js

window.shopifyFrontendHelper = new ShopifyFrontendHelper/* default */.Z();
// EXTERNAL MODULE: ./js/utils/auto-product-to-cart.js
var auto_product_to_cart = __webpack_require__(807);
// EXTERNAL MODULE: ./js/utils/engraving.js
var engraving = __webpack_require__(402);
// EXTERNAL MODULE: ./js/utils/maps.js
var maps = __webpack_require__(285);
// EXTERNAL MODULE: ./js/utils/product-button.js
var product_button = __webpack_require__(664);
// EXTERNAL MODULE: ./js/utils/scrollToAnchor.js
var scrollToAnchor = __webpack_require__(524);
// EXTERNAL MODULE: ./js/partials/loading.js
var loading = __webpack_require__(832);
;// CONCATENATED MODULE: ./js/theme.js








}();
/******/ })()
;